// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2Wu1I","header":"PatientQuestionnaire_header__Gwco0","info":"PatientQuestionnaire_info__3lPkK"};